import { ThemeProvider } from '@emotion/react'
import { Box, Container } from '@mui/material'
import MUIDataTable from 'mui-datatables'
import * as React from 'react'
import theme from '../../../theme'
import api from '../../../services/api'
import { module } from './FormDialog'
import { useNavigate } from 'react-router-dom'
import moment from "moment";
import 'moment/locale/pt-br'

export default function(props){
    const navigate = useNavigate()
    const [data, setData] = React.useState()

    React.useEffect(()=>{
        api.get(`${module}/${props.empresa_id}`)
        .then(res => setData(res.data)).catch((err) => {
            if(err.response.status==401){
              navigate('/401')
            }
            setData()
          })
    },[props.empresa_id])

    const columns =[
        {
            name:'id',
            label:'Id',
            options:{
                display: false
            }
        },
        {
            name:'description',
            label: "Descrição",
            options: {
                filter: true,
                sort: true,}
        },
        {
            name:'last_utilization',
            label: "Ultima Utilização",
            options: {
                filter: true,
                sort: true,
                 customBodyRender: value => {
                    return value ? moment(value).format('DD/MM/YYYY HH:mm:ss') : 'Nunca Utilizado'
            }
        }
        },
    ]

    const options = {
        filterType: 'checkbox',
        rowsPerPageOptions : [30, 50, 100, 500],
        rowsPerPage: 30,
        rowHover: false,
        print: false,
        selectableRows: 'none' ,
        download: false,
    }
    return(
        <Container  maxWidth='lg' sx={{ mt: 4, mb: 4 }}>
            <ThemeProvider theme={theme}>
            <Box sm={12} lg={10}>
            <MUIDataTable
            title={"Tokens Empresa"}
            data={data}
            columns={columns}
            options={options}
            />
            </Box>
        </ThemeProvider>
          </Container>
    )
}
